import React from "react";

export const IconContainer = ({
  size,
  className,
  icon
}) => {
  return (
    <div
      className={`flex items-center gap-2 justify-center relative ${size === "x-small" ? "w-4" : (size === "default") ? "w-5" : size === "medium" ? "w-6" : size === "large" ? "w-8" : size === "x-large" ? "w-10" : "w-3"} ${size === "x-small" ? "h-4" : (size === "default") ? "h-5" : size === "medium" ? "h-6" : size === "large" ? "h-8" : size === "x-large" ? "h-10" : "h-3"} ${className}`}
    >
      {icon}
    </div>
  );
};
